<div [style.min-height.px]="minHeight" class="flex flex-col justify-between">
	<div class="flex flex-col gap-[24px] grow">
		<div *ngIf="usePasscodeForm">
			<ng-container *ngTemplateOutlet="header"></ng-container>
		</div>
		<div>
			<ng-container *ngIf="usePasscodeForm else passcode1">
				<ng-container *ngTemplateOutlet="body"></ng-container>
			</ng-container>
		</div>
	</div>
	<div *ngIf="usePasscodeForm">
		<ng-container *ngTemplateOutlet="footer"></ng-container>
	</div>
</div>


<ng-template #header>
	<div class="flex flex-col gap-[8px]">
		<div class="text-[#1A1A1A] leading-[24.48px] text-[18px] font-bold">
			{{title}}
		</div>
		<div class="text-[#4D4D4D] leading-[19.6px] text-[14px] font-normal">
			{{description}}
		</div>
	</div>
</ng-template>

<ng-template #passcode1>
	<div class="border-[#E5E5E5] border-solid border-[1px] rounded-[12px] p-[16px]">
		<app-kamona-otp [noOfPin]="noOfPasscodeBox" id="" type="password" idV2="newPasscode"
						(emitInput)="setNewPasscode($event)"
						[version]="KamonaOtpVersion.version_2">
		</app-kamona-otp>
	</div>
</ng-template>

<ng-template #body>
	<div class="flex flex-col gap-[24px] justify-center">
		<div class="flex flex-col gap-[10px]">
			<div class="text-[14px] font-medium text-black leading-[19.6px]">
				{{newPasscodeLabel}}
			</div>
			<ng-container *ngTemplateOutlet="passcode1"></ng-container>
		</div>
		<ng-container *ngIf="useConfirmPasscode">
			<div class="flex flex-col gap-[10px]">
				<div class="text-[14px] font-medium text-black leading-[19.6px]">
					{{confirmPasscodeLabel}}
				</div>
				<div class="border-[#E5E5E5] border-solid border-[1px] rounded-[12px] p-[16px]">
					<app-kamona-otp [noOfPin]="noOfPasscodeBox" id="." type="password" idV2="confirmPasscode"
									(emitInput)="setConfirmPasscode($event)"
									[version]="KamonaOtpVersion.version_2">
					</app-kamona-otp>
				</div>
			</div>
		</ng-container>
	</div>
</ng-template>

<ng-template #footer>
	<div class="mt-[24px]">
		<div [ngClass]="{'max-w-[335px] ml-auto':!hideBackBtn}"
			 class="flex items-center justify-end gap-[16px]">
			<div *ngIf="!hideBackBtn" (click)="goBack()"
				 [ngClass]="{'gray-out': submitting}"
				 class="back-btn grow text-center">{{cancelBtnText}}</div>
			<div class="kamona-desktop-button-wrapper-v2 grow">
				<app-kamona-custom-button
						(submitForm)="submit()"
						[isBlock]="true"
						[isDisabled]="!((newPasscode?.length === noOfPasscodeBox) && (confirmPasscode?.length === noOfPasscodeBox))"
						[isSubmitting]="submitting"
						[type]="'primary'"
						[text]="btnText">
				</app-kamona-custom-button>
			</div>
		</div>
	</div>
</ng-template>


